module.exports = __webpack_public_path__ + "static/media/zoomIn.0030e8ef.svg";